module.exports = __webpack_public_path__ + "static/media/6.7e05e2f1.jpg";